import React from 'react';
import './Gauge.css';

const Gauge = (props) => {
  let color;
  if (props.score >= 75) {
    color = '#008000';
  } else if ((props.score >= 50) && (props.score < 75)) {
    color = '#ffff00';
  } else if ((props.score >= 25) && (props.score < 50)) {
    color = '#ffa500';
  } else {
    color = '#ff0000';
  }
  const transform = {
    transform: `rotate(${props.score * 1.8}deg)`,
    background: color,
  };
  return (
    <div>
      <div id="gauge">
        <div id="meter" style={transform} />
        <div className="scoreBox">
          <div className="score">{ parseInt(props.score, 10) || 0 }</div>
        </div>
      </div>
      <div id="scale">
        <div className="start">0</div>
        <div className="end">100</div>
      </div>
    </div>
  );
};

export default Gauge;



// WEBPACK FOOTER //
// ./src/components/Gauge.js